import { Box, Center, Skeleton, SkeletonText, Spinner } from '@chakra-ui/react'
import { lazy, Suspense } from 'react'

const Editor = lazy(() => import('./Editor'))

const LoadingState = ({
  isNewThread = false,
  editable = true,
}: {
  isNewThread: boolean
  editable: boolean
}): React.ReactElement =>
  editable ? (
    <Box backgroundColor="white">
      <Box height="100px" borderRadius="8px">
        <Center
          width="100%"
          height="100%"
          className={`editor-container ${isNewThread ? 'new-thread' : ''}`}
        >
          <Spinner />
        </Center>
      </Box>
    </Box>
  ) : (
    <Box padding="2">
      <SkeletonText mt="4" noOfLines={4} spacing="4" skeletonHeight="2" />
    </Box>
  )

const LazyEditor = props => (
  <Suspense fallback={<LoadingState {...props} />}>
    <Editor {...props} />
  </Suspense>
)

export default LazyEditor
